import { useState, useEffect } from 'react';
import { reportConfig } from '../../utils/config/tableReportConfig';
import { getDynamicSelectData } from '../../utils/api/data';
import { config as customConfig } from "../../config/Constants";
import Cookies from 'js-cookie';
import Axios from 'axios';

export function useScoreboardData(reportName) {
  const config = reportConfig[reportName?.toLowerCase()];
  const totalConfig = reportConfig['carrier scorecard totals'];
  const [reportData, setReportData] = useState(null);
  const [totals, setTotals] = useState(null);

  const percentFields = [
    'PERCENT_PICKUP_ON_TIME',
    'PERCENT_DELIVERY_ON_TIME',
    'PERCENT_HAS_PODS',
    'PERCENT_DAMAGE_FREE',
    'PERCENT_QUOTE_MATCH',
    'TOTAL_SCORE',
  ];

  const formatPercents = (data) =>
    data.map((row) =>
      Object.fromEntries(
        Object.entries(row).map(([key, val]) => [
          key,
          percentFields.includes(key) && val != null ? `${val}%` : val,
        ])
      )
    );

  useEffect(() => {
    const fetchData = async () => {
    const [response, totals] = await Promise.all([
        getDynamicSelectData({ ...config, whereValue: config.getWhereValue() }),
        getDynamicSelectData({ ...totalConfig, whereValue: totalConfig.getWhereValue() }),
    ]);

    const totalRow = totals[0] ? { ...totals[0], isTotal: true } : {};
    const merged = [...formatPercents(response), formatPercents([totalRow])[0]];

    setReportData({ data: merged, size: 'small' });
    setTotals(totals[0]);
    };

    const fetchDummyData = async () => {
      const [reportResponse, totalsResponse] = await Promise.all([
      Axios.get(customConfig.url.GET_REPORT, {
        params: {
          reportName: 'scorecardResponse',
          companyName: Cookies.get('cp-cn'),
        },
      }),
      Axios.get(customConfig.url.GET_REPORT, {
        params: {
          reportName: 'scorecardTotals',
          companyName: Cookies.get('cp-cn'),
        },
      }),
    ]);
      setReportData({data: reportResponse.data.report})
      setTotals(totalsResponse.data.report[0]);
    };

    if (reportName && config && Cookies.get('cp-cn') !== 'GTMS-CP') fetchData();
    if (reportName && config && Cookies.get('cp-cn') === 'GTMS-CP') fetchDummyData();
  }, [reportName]);

  return { reportData, totals };
}
